import { useEffect } from 'react';

function DetectCopyPaste() {
  useEffect(() => {
    const handleCopy = (event) => {
      // eslint-disable-next-line no-console
      console.log('Content has been copied:', event.clipboardData.getData('text'));
    };

    const handlePaste = (event) => {
      // eslint-disable-next-line no-console
      console.log('Content has been pasted:', event.clipboardData.getData('text'));
    };

    document.addEventListener('copy', handleCopy);
    document.addEventListener('paste', handlePaste);

    return () => {
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('paste', handlePaste);
    };
  }, []);
}

export default DetectCopyPaste;
